<div class="se-side-details__container">
    <ng-container *ngIf="details.length > 0; else itemsNoResult">
        <se-side-details-item [ngClass]="{'three-third-height': showDetailsNote, 'full-height': !showDetailsNote }" [details]="details"></se-side-details-item>

        <se-side-details-note class="one-third-height" *ngIf="showDetailsNote" [description]="details[0].data.reasonForStudy ?? ''"></se-side-details-note>
    </ng-container>

    <ng-template #itemsNoResult>
        <div class="se-side-details__no-item">
            <span>{{ koMessage | translate }}</span>
        </div>
    </ng-template>
</div>


